export const observeAffirm = function(){
    const affirmElements = document.querySelectorAll(".affirm-message, .affirm-as-low-as, .affirm-checkout-promo-container");
    if( affirmElements.length ){
        const callback = function(mutations) {
            mutations.forEach(function(mutation) {
                if( mutation.type === "childList" ){
                    const nestedObserver = new MutationObserver(callback);
                    mutation.addedNodes.forEach(function(node){
                        if( node.classList && node.classList.contains("affirm-as-low-as") ){
                            nestedObserver.observe(node, {
                                childList: true
                            });
                        }else if( node.classList && node.classList.contains("affirm-ala-price") && node.innerText ){
                            document.body.classList.add("affirm-ala-price-loaded");
                            document.querySelectorAll(".affirm-amount").forEach(function(element){
                                element.innerText = node.innerText;
                            });
                        }
                    });
                }
            });
        }
        const observer = new MutationObserver(callback);
        affirmElements.forEach(function(element){
            observer.observe(element, {
                childList: true
            });
        });
    }
}